/** Заглушка несуществующего раздела кабинета. */
import { SearchX } from 'lucide-react'
import { Button } from '@/design-system/components/primitives/button'
import { EmptyState } from '@/design-system/components/feedback/empty-state'
import { useNavigate } from 'react-router-dom'

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <EmptyState
      icon={SearchX}
      title="Страница не найдена"
      description="Возможно, раздел ещё не реализован"
      action={
        <Button variant="secondary" onClick={() => navigate('/')}>
          На главную
        </Button>
      }
    />
  )
}
